import React from "react";
import Card from 'react-bootstrap/Card'
import '../styles/card.css'
import { graphql, Link } from "gatsby";
import ReactMarkdown from 'react-markdown';


const StatCard = ({ id, styleId, titleClass, title, subtitle, description, icon, url }) => {

  return (

    <Link to={url}>
      <Card key={id} className="stat-card" id={styleId}>

        <Card.Body>
          {icon}
          {title && <Card.Title>{title}</Card.Title>}
          {subtitle && <Card.Subtitle>{subtitle}</Card.Subtitle>}

          {description && <Card.Text><ReactMarkdown>{description.props.children}</ReactMarkdown></Card.Text>}

        </Card.Body>
      </Card>
    </Link>
  )
}

export default StatCard;